import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import commonService from 'app/core/services/commonService';
import { RootState } from 'app/store/types';
import { initFetchCommonDataAction, fetchMemberProfileAction } from 'app/store/common/actions';
import Header from 'app/common/layouts/Header';
import Footer from 'app/common/layouts/Footer';
import ModalCollection from 'app/common/components/Modals/ModalCollection';
import AsyncSpinner from 'app/common/components/Spinner/AsyncSpinner';
import Reminder from 'app/common/components/Reminder';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'app/core/router/paths';

const MainLayout: React.FC = (props) => {
  const routerLocation = useLocation();
  const reduxDispatch = useDispatch();
  const authorizationState = useSelector((state: RootState) => state.common.member.authorization);

  /**
   * @description 生成 Session id
   */
  useEffect(() => {
    commonService.generateSessionId();
  }, []);

  /**
   * @description 組件初始化後執行的 Effect
   */
  useEffect(() => {
    // 初始取得系統共用選項資料
    reduxDispatch(initFetchCommonDataAction());
  }, [reduxDispatch]);

  /**
   * @description 取得會員資料
   */
  useEffect(() => {
    // 若為登入狀態，取得會員資料並緩存
    if (authorizationState) {
      reduxDispatch(fetchMemberProfileAction({}));
    }
  }, [authorizationState, reduxDispatch]);

  /**
   * @description 根據 HM1240200E (可導覽-網頁標題) 準則，切換路由時變更標題文字
   */
  useEffect(() => {
    switch (routerLocation.pathname) {
      case ROUTES.HOME__SITE_MAP:
        document.title = '網站導覽';
        break;
      case ROUTES.HOME__TRAVEL_INSURANCE:
        document.title = 'E好保旅行平安保險';
        break;
      case ROUTES.SERVICE__QUERY_POLICY__LIST:
        document.title = '網路保單查詢';
        break;
      default:
        document.title = '臺銀人壽網路投保';
        break;
    }
  }, [routerLocation.pathname]);

  return (
    <>
      <Header />
      {/* 中央內容區塊：ALT+C 放置各頁 */}
      <main>
        {props.children}
        <Reminder />
      </main>
      <Footer />
      <ModalCollection />
      <AsyncSpinner />
    </>
  );
};

export default MainLayout;
